$(document).ready(function () {
    var deviceCheck = new deviceDetect();

    //-----------------------------------------------------------------------
    // Vídeos de la home
    //-----------------------------------------------------------------------
    // if (0 < $("#home-section0").length) {
    //     if (
    //         "desktoplg" == deviceCheck.device ||
    //         "desktop" == deviceCheck.device
    //     ) {
    //         video_load = "desktop";

    //         var $video_template =
    //             '<video id="myVideo" class="videos-home" loop muted data-autoplay>';
    //         $video_template +=
    //             '<source src="/media/uploads/video/lantek-' +
    //             video_load +
    //             '-op.mp4" type="video/mp4">';
    //         $video_template +=
    //             '<source src="/media/uploads/video/lantek-' +
    //             video_load +
    //             '-op.webm" type="video/webm">';
    //         $video_template += "</video>";

    //         $("#home-section0").prepend($video_template);
    //     }
    // }
    //-----------------------------------------------------------------------
    // FIN --> Vídeos de la home
    //-----------------------------------------------------------------------

    // Menu toggle
    var $menu = $(".nuevo-megamenu");
    $("#menu-toggle").click(function (e) {
        $menu.toggleClass("nuevo-megamenu-movil");

        e.preventDefault();
    });

    $(".dropdown-toggle").mouseenter(function () {
        var $this = $(this);
        var flecha_x = $this.offset().left;
        var flecha_gap = 30;

        $this
            .parent()
            .find(".mega-menu .mega-menu-flecha")
            .css("left", flecha_x + flecha_gap + "px");
    });

    //-----------------------------------------------------------------------
    // Menu productos
    //-----------------------------------------------------------------------
    $(".menu-producto").hover(function () {
        var ancho = $(window).width();
        if (ancho > 992) {
            $(this).find(".submen").toggleClass("show");
        }
    });

    //-----------------------------------------------------------------------
    // Submenu productos
    //-----------------------------------------------------------------------
    /*$('.menu-producto .submen-producto').hover(function() {
        var ancho = $(window).width();
        if (ancho > 992) {
			$(this).find('.submen-producto-link').toggleClass('superc-flecha');
            $(this).find('.soft-description').toggleClass('show');
        }
	});*/

    //-----------------------------------------------------------------------
    // Capabilities
    //-----------------------------------------------------------------------
    $(".capabilities .menu-producto").hover(function () {
        var ancho = $(window).width();
        if (ancho > 992) {
            $(this).find(".soft-description").toggleClass("show");
        }
    });

    //-----------------------------------------------------------------------
    // Dropdowns menu móvil
    //-----------------------------------------------------------------------
    if ($("header").hasClass("isMobile")) {
        var $menudrop = $(".dropdown .dropdown-toggle");

        $menudrop.click(function (e) {
            e.preventDefault();

            $(this).parent().find(".dropdown-menu").slideToggle("slow");
        });
    }
    //-----------------------------------------------------------------------
    // FIN --> Dropdowns menu móvil
    //-----------------------------------------------------------------------

    // fullpage.js

    // Página Software.
    // if ($("#fullpage-software").length) {
    //     $("#fullpage-software").fullpage({
    //         anchors: [
    //             "Expert",
    //             "Flex3d",
    //             "MES",
    //             "Integra",
    //             "Analytics",
    //             "MES+",
    //             "footer",
    //         ],
    //         responsiveWidth: 1025,
    //         verticalCentered: true,
    //         navigation: true,
    //         scrollBar: true,
    //         navigationPosition: "left",
    //         licenseKey: "B28F490A-90894E10-A1806D0D-9D46BD33",
    //     });
    // }

    // // Página Media.
    // if ($("#fullpage-media").length) {
    //     $("#fullpage-media").fullpage({
    //         verticalCentered: true,
    //         responsiveWidth: 980,
    //         slidesNavigation: true,
    //         scrollBar: true,
    //         licenseKey: "B28F490A-90894E10-A1806D0D-9D46BD33",
    //     });
    // }

    // // Página Home.
    // if ($("#fullpage-home").length) {
    //     $("#fullpage-home").fullpage({
    //         verticalCentered: true,
    //         responsiveWidth: 1025,
    //         slidesNavigation: true,
    //         scrollBar: true,
    //         licenseKey: "B28F490A-90894E10-A1806D0D-9D46BD33",
    //     });
    // }

    // if ($("#fullpage").length) {
    //     $("#fullpage").fullpage({
    //         verticalCentered: true,
    //         responsiveWidth: 1025,
    //         slidesNavigation: true,
    //         normalScrollElements: ".scrollable-element",
    //         scrollBar: true,
    //         licenseKey: "B28F490A-90894E10-A1806D0D-9D46BD33",
    //         afterLoad: function (origin, destination, direction) {
    //             var totalSlides = $(".fp-section").length - 1;

    //             if (
    //                 destination.index > totalSlides - 2 &&
    //                 direction == "down"
    //             ) {
    //                 $("#more-content").fadeOut().addClass("inactive");
    //             } else {
    //                 if ($("#more-content").hasClass("inactive")) {
    //                     $("#more-content").fadeIn().removeClass("inactive");
    //                 }
    //             }
    //         },
    //     });
    // }

    $(".thumbnails.owl-carousel").owlCarousel({
        loop: true,
        nav: true,
        responsive: {
            0: {
                items: 1,
            },
            768: {
                items: 3,
            },
        },
    });

    // Aviso legal accordion
    $(".legal-accordion__button").on("click", function () {
        var content = $(this)
            .parent()
            .find(".legal-accordion__content");

        if (content.hasClass("open")) {
            $(this)
                .parent()
                .find(".legal-accordion__content")
                .slideToggle();
            content.removeClass("open");
            $(this)
                .parent()
                .find(".legal-accordion__more")
                .removeClass("open");
        }
        else {
            $(this).parent().find(".legal-accordion__content").slideToggle();
            $(this).parent().find(".legal-accordion__content").toggleClass("open");
            $(this).find(".legal-accordion__more").toggleClass("open");
        }
    });

    $(document).on("click", "#moveDown", function () {
        $.fn.fullpage.moveSectionDown();
    });

    $(document).on("click", ".youtube-thumbnail", function (e) {
        e.preventDefault();

        // current iframe and h2 video title to a tmp vars
        var $iframe = $("#youtube-video-iframe");
        var $h2 = $("#youtube-video-title");
        var tempVideoTitle = $h2.text();
        var tempVideoSrc = $iframe.attr("src");
        var tempVideoTitleLang = $iframe.data("title");
        var tempThumbnailUrl = $iframe.data("thumbnailurl");
        var tempThumbnailWidth = $iframe.data("thumbnailwidth");
        var tempThumbnailHeigth = $iframe.data("thumbnailheigth");

        // thumbnail click data
        var $this = $(this);
        var videoSrc = $this.data("src");
        var videoTitle = $this.data("title");
        var videoTitleLang = $this.attr("title");
        var $img = $this.find("img");
        var thumbnailUrl = $img.attr("src");
        var thumbnailWidth = $img.attr("width");
        var thumbnailHeigth = $img.attr("heigth");
        var $spanTitle = $this.find("span");

        // change values to current iframe using click thumbnail data
        $iframe.data("title", videoTitleLang);
        $iframe.data("thumbnailurl", thumbnailUrl);
        $iframe.data("thumbnailwidth", thumbnailWidth);
        $iframe.data("thumbnailheigth", thumbnailHeigth);
        $iframe.attr("src", videoSrc);
        $h2.text(videoTitle);

        // change values click thumbnail data using saved temp data
        $this.data("src", tempVideoSrc);
        $this.data("title", tempVideoTitle);
        $this.attr("title", tempVideoTitleLang);
        $img.attr("src", tempThumbnailUrl);
        $img.attr("width", tempThumbnailWidth);
        $img.attr("heigth", tempThumbnailHeigth);
        $spanTitle.text(tempVideoTitle);
    });

    $(document).on("click", ".podcast-thumbnail", function (e) {
        e.preventDefault();

        // current iframe
        var iframeId = "podcast-iframe";
        var $iframe = $("#" + iframeId);
        var tempPodcastTitle = $iframe.data("title");
        var tempPodcastTitleLang = $iframe.data("title-lang");
        var tempPodcastPlayer = $iframe.data("player");
        var tempPodcastLogo = $iframe.data("logo");

        // thumbnail click data
        var $this = $(this);
        var podcastTitle = $this.data("title");
        var podcastTitleLang = $this.attr("title");
        var podcastPlayer = $this.data("player");
        var podcastLogo = $this.data("logo");
        var $img = $this.find("img");
        var $spanTitle = $this.find("span");

        // change values to current iframe using click thumbnail data
        $iframe.data("title", podcastTitle);
        $iframe.data("title-lang", podcastTitleLang);
        $iframe.data("player", podcastPlayer);
        $iframe.data("logo", podcastLogo);
        $iframe.data("src", podcastPlayer);
        $iframe.attr("src", podcastPlayer);

        // change values click thumbnail data using saved temp data
        $this.data("title", tempPodcastTitle);
        $this.data("title-lang", tempPodcastTitleLang);
        $this.attr("title", tempPodcastTitleLang);
        $this.data("player", tempPodcastPlayer);
        $this.data("logo", tempPodcastLogo);
        $img.attr("src", tempPodcastLogo);
        $spanTitle.text(tempPodcastTitle);
    });

    $(document).on("click", ".magazine-thumbnail", function (e) {
        e.preventDefault();

        // current iframe
        var iframeId = "magazine-iframe";
        var $iframe = $("#" + iframeId);
        var $iframeTitle = $("#iframe-title");
        var tempMagazineTitulo = $iframe.data("titulo");
        var tempMagazineImagen = $iframe.data("imagen");
        var tempMagazineUrl = $iframe.data("url");

        // thumbnail click data
        var $this = $(this);
        var magazineTitulo = $this.data("titulo");
        var magazineImagen = $this.data("imagen");
        var magazineUrl = $this.data("url");
        var $img = $this.find("img");
        var $spanTitle = $this.find("span");

        // change values to current iframe using click thumbnail data
        $iframe.data("titulo", magazineTitulo);
        $iframe.data("imagen", magazineImagen);
        $iframe.data("url", magazineUrl);
        $iframe.attr("src", magazineUrl);
        $iframeTitle.text(magazineTitulo);

        // change values click thumbnail data using saved temp data
        $this.data("titulo", tempMagazineTitulo);
        $this.attr("title", tempMagazineTitulo);
        $this.data("imagen", tempMagazineImagen);
        $this.data("url", tempMagazineUrl);
        $img.attr("src", tempMagazineImagen);
        $spanTitle.text(tempMagazineTitulo);
    });

    // Iniciar intervalo si es la página de producto.
    var $productModal = $("#modalproducto");
    if ($productModal.length) {
        startModalInterval();
    }

    var $newsletterModal = $("#modalnewsletter");
    if ($newsletterModal.length) {
        startNewsletterInterval();
    }

    function readCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(";");

        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];

            while (" " == c.charAt(0)) {
                c = c.substring(1, c.length);
            }

            if (0 == c.indexOf(nameEQ)) {
                return c.substring(nameEQ.length, c.length);
            }
        }

        return null;
    }

    var csrf = readCookie("csrf_cookie_name");

    function cargarVideos(idvideo) {
        var idproducto = $("#idproducto").val();

        $.post(
            urlVideos,
            "idvideo=" +
                idvideo +
                "&idproducto=" +
                idproducto +
                "&csrf_test_name=" +
                csrf,
            function (data) {
                if ("" != data) {
                    $("#cargar_videos").html(data);
                    $(".cargar_video").click(function () {
                        var idvideo = $(this).attr("id");
                        cargarVideos(idvideo);
                    });
                }
            }
        );
    }

    /*! modernizr 3.5.0 (Custom Build) | MIT *
     * https://modernizr.com/download/?-touchevents-setclasses !*/
    !(function (e, n, t) {
        function o(e, n) {
            return typeof e === n;
        }
        function s() {
            var e, n, t, s, a, i, r;
            for (var l in c)
                if (c.hasOwnProperty(l)) {
                    if (
                        ((e = []),
                        (n = c[l]),
                        n.name &&
                            (e.push(n.name.toLowerCase()),
                            n.options &&
                                n.options.aliases &&
                                n.options.aliases.length))
                    )
                        for (t = 0; t < n.options.aliases.length; t++)
                            e.push(n.options.aliases[t].toLowerCase());
                    for (
                        s = o(n.fn, "function") ? n.fn() : n.fn, a = 0;
                        a < e.length;
                        a++
                    )
                        (i = e[a]),
                            (r = i.split(".")),
                            1 === r.length
                                ? (Modernizr[r[0]] = s)
                                : (!Modernizr[r[0]] ||
                                      Modernizr[r[0]] instanceof Boolean ||
                                      (Modernizr[r[0]] = new Boolean(
                                          Modernizr[r[0]]
                                      )),
                                  (Modernizr[r[0]][r[1]] = s)),
                            f.push((s ? "" : "no-") + r.join("-"));
                }
        }
        function a(e) {
            var n = u.className,
                t = Modernizr._config.classPrefix || "";
            if ((p && (n = n.baseVal), Modernizr._config.enableJSClass)) {
                var o = new RegExp("(^|\\s)" + t + "no-js(\\s|$)");
                n = n.replace(o, "$1" + t + "js$2");
            }
            Modernizr._config.enableClasses &&
                ((n += " " + t + e.join(" " + t)),
                p ? (u.className.baseVal = n) : (u.className = n));
        }
        function i() {
            return "function" != typeof n.createElement
                ? n.createElement(arguments[0])
                : p
                ? n.createElementNS.call(
                      n,
                      "http://www.w3.org/2000/svg",
                      arguments[0]
                  )
                : n.createElement.apply(n, arguments);
        }
        function r() {
            var e = n.body;
            return e || ((e = i(p ? "svg" : "body")), (e.fake = !0)), e;
        }
        function l(e, t, o, s) {
            var a,
                l,
                f,
                c,
                d = "modernizr",
                p = i("div"),
                h = r();
            if (parseInt(o, 10))
                for (; o--; )
                    (f = i("div")),
                        (f.id = s ? s[o] : d + (o + 1)),
                        p.appendChild(f);
            return (
                (a = i("style")),
                (a.type = "text/css"),
                (a.id = "s" + d),
                (h.fake ? h : p).appendChild(a),
                h.appendChild(p),
                a.styleSheet
                    ? (a.styleSheet.cssText = e)
                    : a.appendChild(n.createTextNode(e)),
                (p.id = d),
                h.fake &&
                    ((h.style.background = ""),
                    (h.style.overflow = "hidden"),
                    (c = u.style.overflow),
                    (u.style.overflow = "hidden"),
                    u.appendChild(h)),
                (l = t(p, e)),
                h.fake
                    ? (h.parentNode.removeChild(h),
                      (u.style.overflow = c),
                      u.offsetHeight)
                    : p.parentNode.removeChild(p),
                !!l
            );
        }
        var f = [],
            c = [],
            d = {
                _version: "3.5.0",
                _config: {
                    classPrefix: "",
                    enableClasses: !0,
                    enableJSClass: !0,
                    usePrefixes: !0,
                },
                _q: [],
                on: function (e, n) {
                    var t = this;
                    setTimeout(function () {
                        n(t[e]);
                    }, 0);
                },
                addTest: function (e, n, t) {
                    c.push({ name: e, fn: n, options: t });
                },
                addAsyncTest: function (e) {
                    c.push({ name: null, fn: e });
                },
            },
            Modernizr = function () {};
        (Modernizr.prototype = d), (Modernizr = new Modernizr());
        var u = n.documentElement,
            p = "svg" === u.nodeName.toLowerCase(),
            h = d._config.usePrefixes
                ? " -webkit- -moz- -o- -ms- ".split(" ")
                : ["", ""];
        d._prefixes = h;
        var m = (d.testStyles = l);
        Modernizr.addTest("touchevents", function () {
            var t;
            if (
                "ontouchstart" in e ||
                (e.DocumentTouch && n instanceof DocumentTouch)
            )
                t = !0;
            else {
                var o = [
                    "@media (",
                    h.join("touch-enabled),("),
                    "heartz",
                    ")",
                    "{#modernizr{top:9px;position:absolute}}",
                ].join("");
                m(o, function (e) {
                    t = 9 === e.offsetTop;
                });
            }
            return t;
        }),
            s(),
            a(f),
            delete d.addTest,
            delete d.addAsyncTest;
        for (var v = 0; v < Modernizr._q.length; v++) Modernizr._q[v]();
        e.Modernizr = Modernizr;
    })(window, document);

    var $softnavmenu = $(".has-submenu");

    if (Modernizr.touchevents) {
        $softnavmenu.find(".arrow").on("click", function () {
            var arrow = $(this);

            arrow.toggleClass("collapsed");
            arrow.parent().next("ul").stop().slideToggle({ duration: 200 });
        });
    } else {
        $softnavmenu.hover(
            function () {
                var el = $(this);

                el.find(".arrow").removeClass("collapsed");
                el.find("ul").stop().slideDown({ duration: 200 });
            },
            function () {
                var el = $(this);

                el.find(".arrow").addClass("collapsed");
                el.find("ul").stop().slideUp({ duration: 200 });
            }
        );
    }

    // carga de vídeos
    $(".cargar_video").click(function () {
        var idvideo = $(this).attr("id");
        cargarVideos(idvideo);
    });

    // carousel
    $("#myCarousel").carousel();

    if (767 >= $(window).width()) {
        $("#myCarousel").carousel("pause");
    }

    $(window).resize(function () {
        if (767 >= $(window).width()) {
            $("#myCarousel").carousel("pause");
        } else {
            $("#myCarousel").carousel();
        }
    });

    // formulario customers
    $("#form-filters").submit(function (event) {
        if ($("#form-filter").attr("action") == urlClientes) {
            event.preventDefault();
        }

        var pro = $("#product").children(":selected").attr("id");
        var act = $("#activity").children(":selected").attr("id");
        var mac = $("#machine").children(":selected").attr("id");
        var tec = $("#tech").children(":selected").attr("id");
        var sec = $("#sector").children(":selected").attr("id");
        var lan = $("#language").children(":selected").attr("id");

        var url = urlClientes + "/";
        var uri = "";

        if (undefined != pro) {
            if (uri != "") {
                uri += "-";
            }

            uri += pro;
        }

        if (undefined != act) {
            if (uri != "") {
                uri += "-";
            }

            uri += act;
        }

        if (undefined != mac) {
            if (uri != "") {
                uri += "-";
            }

            uri += mac;
        }

        if (undefined != tec) {
            if (uri != "") {
                uri += "-";
            }

            uri += tec;
        }

        if (undefined != sec) {
            if (uri != "") {
                uri += "-";
            }

            uri += sec;
        }

        if (undefined != lan) {
            if (uri != "") {
                uri += "-";
            }

            uri += lan;
        }

        url += uri;
        $("#form-filters").attr("action", url + "#success-stories-search");
    });

    // formulario customers por palabra clave
    $("#form-filters-term #term").change(function () {
        var url = urlClientes + "/" + $(this).val() + "#success-stories-search";
        $("#form-filters-term").attr("action", url);
    });

    $("#all-success-stories").click(function (event) {
        event.preventDefault();
        $(".oculto").show();
    });

    if ("Internet Explorer" == browserAgent) {
        // placeholder
        $("input").each(function (index, element) {
            var placeholder = $(this).attr("placeholder");

            if ($(this).attr("type") == "text") {
                $(this).val(placeholder);
            }
        });

        $("textarea").each(function (index, element) {
            var placeholder = $(this).attr("placeholder");
            $(this).val(placeholder);
        });

        $("[placeholder]")
            .focus(function () {
                var input = $(this);

                if (input.val() == input.attr("placeholder")) {
                    input.val("");
                    input.removeClass("placeholder");
                }
            })
            .blur(function () {
                var input = $(this);

                if (
                    input.val() == "" ||
                    input.val() == input.attr("placeholder")
                ) {
                    input.addClass("placeholder");
                    input.val(input.attr("placeholder"));
                }
            });
    }

    // tabs
    $("#myTab a").click(function (e) {
        e.preventDefault();
        $(this).tab("show");
    });

    if ($(".page-header h1").length > 0) {
        if (1024 > $(window).width()) {
            $("html, body").animate(
                {
                    scrollTop: $(".page-header h1").offset().top,
                },
                800
            );
        }
    }

    $("a#product-family-link").on("click", function (event) {
        event.preventDefault();
        $("html, body").animate(
            {
                scrollTop: $("#products-family").offset().top,
            },
            800
        );
    });

    // Home contact.
    if (typeof gracias !== "undefined" && gracias !== null && gracias) {
        $("html, body").animate(
            {
                scrollTop: $("#contact-home").offset().top,
            },
            800
        );
    }

    //Lantek Factory Button
    $(function () {
        if ($(0 < ".lantek-factory-fixed").length) {
            var offset = $(".lantek-factory-fixed").offset();
            var topPadding = 100;

            $(window).scroll(function () {
                if ($(window).scrollTop() > offset.top) {
                    $(".lantek-factory-fixed")
                        .stop()
                        .animate({
                            marginTop:
                                $(window).scrollTop() - offset.top + topPadding,
                        });
                } else {
                    $(".lantek-factory-fixed").stop().animate({
                        marginTop: 0,
                    });
                }
            });
        }
    });

    // Contacto.
    if (typeof google !== 'undefined') {
        (function ($) {
            if (0 == $("#map_canvas").length) {
                return;
            }

            function initialize(idgrupo) {
                var latlng = new google.maps.LatLng(20.0, -10.0);
                var myOptions = {
                    zoom: zoom - 1,
                    center: latlng,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    scrollwheel: false,
                };

                var map = new google.maps.Map(
                    document.getElementById("map_canvas"),
                    myOptions
                );

                // if (isSiteURL) {
                //     // SOLO PARA LA HOME
                //     var styles = [
                //         {
                //             stylers: [
                //                 {
                //                     saturation: -100,
                //                 },
                //             ],
                //         },
                //     ];

                //     map.setOptions({ styles: styles });
                // }

                var markersArray = [];
                var img = "marker-exhibitions.png";
                var enlace = "";

                $.ajax({
                    type: "POST",
                    url: urlPresence,
                    processData: true,
                    // data: "idgrupo=" + idgrupo + "&csrf_test_name=" + csrf,
                    data: "&csrf_test_name=" + csrf,
                    dataType: "json",
                    success: function (data) {
                        processData(data);
                    },
                });

                function processData(data) {
                    for (i = 0; i < data.length; i++) {
                        if (data[i]["idtipo"] == 1) {
                            img = "marker-offices.png";
                        } else if (data[i]["idtipo"] == 2) {
                            img = "marker-resellers.png";
                        } else if (data[i]["idtipo"] == 3) {
                            img = "marker-exhibitions.png";
                        }

                        if (data[i]["mostrar_ficha"] == 1) {
                            enlace =
                                '<h4><a href="' +
                                urlSite +
                                "/" +
                                data[i]["seo_url"] +
                                '">' +
                                data[i]["mapa_texto"] +
                                "</a></h4>";
                        } else {
                            enlace = "<h4>" + data[i]["mapa_texto"] + "</h4>";
                        }

                        var point = new google.maps.LatLng(
                            data[i]["mapa_lat"],
                            data[i]["mapa_lon"]
                        );
                        var marker = new google.maps.Marker({
                            position: point,
                            content: enlace, // texto que aparece al hacer click
                            map: map,
                            title: data[i]["mapa_alt"], // texto que aparece al pasar el ratón sobre el punto
                            icon: urlBase + "media/imagenes/" + img, // imagen personalizada
                        });

                        // To add the marker to the map, call setMap();
                        marker.setMap(map);
                        markersArray.push(marker);

                        var contentString = data[i]["mapa_texto"];
                        var infowindow = new google.maps.InfoWindow({
                            content: contentString,
                        });

                        google.maps.event.addListener(marker, "click", function () {
                            infowindow.setContent(this.content);
                            infowindow.open(map, this);
                        });
                    }
                }
            }

            var infowindow = null;
            if ("" === idgrupo) {
                idgrupo = isSiteURL ? "1" : "";
            }

            // Al hacer click en un filtro, volver a cargar el mapa mediante AJAX.
            $(".click_filtro_grupo").click(function () {
                idgrupo = $(this).attr("id");
                $("#all").removeClass("active");

                $(".click_filtro_grupo").each(function (index) {
                    var idgrupo_del = $(this).attr("id");
                    $("#" + idgrupo_del).removeClass("active");
                });

                $(this).addClass("active");
                initialize(idgrupo);
            });

            google.maps.event.addDomListener(window, "resize", function () {
                initialize(idgrupo);
            });
            google.maps.event.addDomListener(window, "load", function () {
                initialize(idgrupo);
            });
        })($);
    }
    // Fin Contacto.

    // Veiss - Presencia global Home
    // Fin Veiss - Presencia global Home

    // // Blog Detail, Communication News Detail.
    // (function($) {
    // 	// plugin initialization with default options
    // 	shareSelectedText('.share-content', {
    // 		tooltipClass: '',    // cool, if you want to customize the tooltip
    // 		sanitize: true,      // will sanitize the user selection to respect the Twitter Max length (recommended)
    // 		buttons: [           // services that you want to enable you can add :
    // 			'twitter',       // - twitter, tumblr, buffer, stumbleupon, digg, reddit, linkedin, facebook
    // 			'facebook',
    // 			'linkedin',
    // 		],
    // 		anchorsClass: '',    // class given to each tooltip's links
    // 		twitterUsername: '', // for twitter widget, will add 'via @twitterUsername' at the end of the tweet.
    // 		facebookAppID: '647608455446961', // Can also be an HTML element inside the <head> tag of your page : <meta property="fb:APP_ID" content="YOUR_APP_ID"/>
    // 		facebookDisplayMode: 'popup', //can be 'popup' || 'page'
    // 		tooltipTimeout: 250  //Timeout before that the tooltip appear in ms
    // 	});
    // })($);
    // Fin Blog Detail, Communication News Detail.

    // Google reCaptcha.
    var $forms = $("form");
    if (0 < $forms.length) {
        $forms.each(function () {
            var $form = $(this);
            var $formButton = $form.find(".btn");
            var $recaptchaField = $form.find(".grecaptchatoken");

            if (0 < $recaptchaField.length) {
                $formButton.click(function (event) {
                    if (!$form.valid()) {
                        return;
                    }

                    event.preventDefault();

                    grecaptcha.ready(function () {
                        grecaptcha
                            .execute(grecaptcha_site_key, {
                                action: $recaptchaField.data("type"),
                            })
                            .then(function (token) {
                                $recaptchaField.val(token);
                                $form.unbind("submit").submit();
                            });
                    });
                });
            }
        });
    }

    // 31/03/2022 -> Omitir que aparezca el modal de polonia en la pagina principal
    // showModalPolonia();

    // Abrir botones de aviso legal si hay un parámetro en la url
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    if (urlParams.has('info')) {
        openLegal(1);
    } else if (urlParams.has('terms')) {
        openLegal(2);
    } else if (urlParams.has('privacy')) {
        openLegal(3);
    }

    $("#form-newsletter").validate();
});

function showModalPolonia() {
    $("#modalPolonia").modal();
    setTimeout(() => {
        $("#modalPolonia").modal("hide");
    }, 10000);
}

// modal de producto
var interval;
var intervalId;

// inicializar intervalo dependiendo si es la primera vez o no. (cookie modal_interval)
function startModalInterval() {
    interval = $.cookie("modal_interval");

    if (typeof interval === "undefined") {
        interval = 60000;
        $.cookie("modal_interval", 120000, { expires: 1 });
    } else {
        interval = $.cookie("modal_interval");
    }

    // Store the id of the interval so we can clear it later
    intervalId = setInterval(function () {
        showModal();
    }, interval);
}

function showModal() {
    $("#modalproducto").modal();
    clearInterval(intervalId);
    startModalInterval();
}
// ./modal de producto
//-------------------------------------------------------------------------

//-----------------------------------------------------------------------
// Modal de newsletter
//-----------------------------------------------------------------------
function startNewsletterInterval() {
    interval = $.cookie("modal_newsletter");

    if (typeof interval === "undefined") {
        interval = 10000;

        intervalId = setInterval(function () {
            showNewsletterModal();
        }, interval);
    }
}

function showNewsletterModal() {
    $("#modalnewsletter").modal();
    clearInterval(intervalId);
}

function setNewsletterCookie() {
    $.cookie("modal_newsletter", interval, { expires: 30 });
}

//-----------------------------------------------------------------------
// FIN Modal de newsletter
//-----------------------------------------------------------------------

//-----------------------------------------------------------------------
// Comprobación de dispositivo
//-----------------------------------------------------------------------
function deviceDetect() {
    this.device = null;

    var cThis = this;

    //Resize eventos
    this.mq_mobile = window.matchMedia(
        "(min-width: 576px) and (max-width: 767px)"
    );
    this.mq_mobile.addListener(function (mql) {
        if (mql.matches) {
            cThis.device = "mobile";
        }
    });

    this.mq_tablet = window.matchMedia(
        "(min-width: 768px) and (max-width: 991px)"
    );
    this.mq_tablet.addListener(function (mql) {
        if (mql.matches) {
            cThis.device = "tablet";
        }
    });

    this.mq_desktop = window.matchMedia(
        "(min-width: 992px) and (max-width: 1199px)"
    );
    this.mq_desktop.addListener(function (mql) {
        if (mql.matches) {
            cThis.device = "desktop";
        }
    });

    this.mq_desktopxl = window.matchMedia("(min-width: 1200px)");
    this.mq_desktopxl.addListener(function (mql) {
        if (mql.matches) {
            cThis.device = "desktoplg";
        }
    });

    //Cuando se carga la página
    if (this.mq_desktopxl.matches) {
        this.device = "desktoplg";
    } else if (this.mq_desktop.matches) {
        this.device = "desktop";
    } else if (this.mq_tablet.matches) {
        this.device = "tablet";
    } else if (this.mq_mobile.matches) {
        this.device = "mobile";
    } else {
        this.device = "mobilesmall";
    }
}

//-----------------------------------------------------------------------
// Abrir botones de aviso legal si hay un parámetro en la url
//-----------------------------------------------------------------------

function openLegal(id) {
    var legalButton = $('#legal .js-legal-'+ id +' .legal-accordion__button');
    
    if (legalButton.length > 0) {
        legalButton.click();

        $('html, body').animate({
            scrollTop: $(legalButton).offset().top
        }, 1000);
    }
}